import { Component, Inject, OnDestroy, Optional, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppNotificationService } from '@core/services/app-notification.service';
import { ConfirmDialogService } from '@shared/components/dialogs/confirm-dialog/confirm-dialog.service';
import { Subject } from 'rxjs';
import { Person } from '@shared/models/person';
import { Company } from '@shared/models/company';
import { WinterStorageBoatAssignment } from '@shared/models/winter-storage-boat-assignment';
import { TranslationService } from '@core/translation/translation.service';
import {
    WinterStorageAssignmentBillingPanelComponent
} from '@bcm-work-flows/winter-storage-assignment-billing-panel/winter-storage-assignment-billing-panel.component';

@Component({
    selector: 'winter-storage-assignment-invoice-positions',
    templateUrl: './winter-storage-assignment-invoice-positions.component.html',
    styleUrls: ['./winter-storage-assignment-invoice-positions.component.scss'],
    standalone: false
})
export class WinterStorageAssignmentInvoicePositionsComponent implements OnDestroy {

    private _unsubscribeAll = new Subject<any>();

    @ViewChild('billingPanel') billingPanel: WinterStorageAssignmentBillingPanelComponent;

    winterStorageAssignment: WinterStorageBoatAssignment;
    subscription = false;
    isSaving: boolean;

    constructor(public dialogRef: MatDialogRef<WinterStorageAssignmentInvoicePositionsComponent>,
                @Optional() @Inject(MAT_DIALOG_DATA) public data: {
                    winterStorageAssignment?: WinterStorageBoatAssignment,
                    subscription?: boolean
                },
                private _appNotificationService: AppNotificationService,
                private _confirmDialogService: ConfirmDialogService) {
        this.dialogRef.addPanelClass('default-dialog');
        this.dialogRef.disableClose = true;
        this.winterStorageAssignment = data?.winterStorageAssignment;
        this.subscription = data?.subscription || false;
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(undefined);
        this._unsubscribeAll.complete();
    }

    onClickClose(): void {
        const formGroup = this.billingPanel?.formGroup;

        if (formGroup?.dirty) {
            return this._confirmDialogService
                .useWarnTheme()
                .setTitle(TranslationService.translate('common.confirm.attention'))
                .setBody(TranslationService.translate('common.unsavedChanges.leavePageBody'))
                .setYesButton({
                    text: TranslationService.translate('common.unsavedChanges.leavePageConfirmYes')
                })
                .setNoButton({
                    text: TranslationService.translate('common.cancel')
                })
                .openWithCallback(() => this.dialogRef.close());
        }

        this.dialogRef.close();
    }

    onClickSaveAndClose(): void {
        const billing = this.billingPanel?.getBillingPayload();

        if (!billing) {
            this.billingPanel?.markAllAsTouched();
            this._appNotificationService.showError(TranslationService.translate('common.checkFieldsHighlight'));
            return;
        }

        this.isSaving = true;

        this.dialogRef.close({
            winterStorageAssignment: this.winterStorageAssignment,
            ...billing,
        });
    }
}
